import { Attributes, ModelBase, NeoModel, Rules } from "@singularsystems/neo-core";

@NeoModel
export default class ExcludedAccountLookup extends ModelBase {
    
    public excludedAccountId: number = 0;

    @Rules.Required()
    @Attributes.Display("Broker")
    public staticServiceProviderFileGroupingId: number | null = null;

    public brokerName: string | null = null;

    @Rules.Required()
    @Rules.StringLength(100)
    public accountNumber: string = "";
}